var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"cta",attrs:{"to":_vm.to || '#'}},[_c('SVGChevronDownLeft'),_c('span',[_vm._t("default")],2),_c('SVGChevronUpRight')],1)}
var staticRenderFns = []

export { render, staticRenderFns }